import { type Mode } from './types';

// Core predicate-based filter
export const baseFilter =
  <T>(predicate: (item: T) => boolean, mode: Mode = 'include') =>
  (source: T[]): T[] =>
    source.filter((item) => (mode === 'include' ? predicate(item) : !predicate(item)));

// Basic value filter
export const filterValue = <T>(values: T[], mode: Mode = 'include') =>
  baseFilter<T>((item) => values.includes(item), mode);

// Property-based filter
export const filterBy = <T, K extends keyof T>(values: T[K][], key: K, mode: Mode = 'include') =>
  baseFilter<T>((item) => values.includes(item[key]), mode);
